<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.HSN_CODE + '  ' + r.DDC_CODE + ' - ' + r.TRADE_NAME" [term]="t"></ngb-highlight>
</ng-template>

<app-page-header [heading]="'Add Damage Products'" [icon]="'fa-flash'" style="height:100px;"></app-page-header>

<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="row">
    <div class=" col-lg-4">
      <label>Purchase Number</label>
      <ngx-select-dropdown (change)="getInvoice();listPurchaseItems();" [(ngModel)]="invoice_data"
                           [config]="utils.dropConfig({displayKey: 'INVOICE',placeholder: 'Select Purchase Details',searchOnKey: 'INVOICE'})"
                           [multiple]="false"
                           [options]="invoice_options" class="form-control select-dropdown"
                           name="sel_tpa_receiver"></ngx-select-dropdown>
    </div>
  </div>
  <div class="clearfix"></div>
  <div *ngIf="damage.purchase_id > 0" class="">
    <div class=" form-group">
      <table class=" table tbl  table-bordered ">
        <thead>
        <tr class="text-center">
          <th class="text-center" width="1%"></th>
          <th class="text-center" width="1%">#</th>
          <th>Item</th>
          <th width="7%">Ava. Qty</th>
          <th width="7%">Purchased Qty</th>
          <th width="7%">Amount</th>
          <th width="7%">Unit Price</th>
          <th width="7%">Damage Qty <span class="text-danger">*</span></th>
          <th width="8%">Damage Amt.</th>
          <th width="17%">Reason <span class="text-danger">*</span></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let i of utils.buildArray(purchase_details.length)">
          <td class="text-center"><input (click)="changeCheckbox(i)" *ngIf="damage.available_qty[i] >0"
                                         [checked]="damage.check[i] == true" type="checkbox"></td>
          <td class="text-center">{{ i + 1 }}</td>
          <td>
            <input (selectItem)="set_item_medicine($event,i)" [(ngModel)]="damage.medicine_data[i]"
                   [class.is-invalid]="searchFailed" [disabled]="damage.check[i] == false"
                   [inputFormatter]="formatter" [ngModelOptions]="{standalone: true}" [ngbTypeahead]="medicine_search"
                   [readOnly]="true"
                   [resultTemplate]="rt" class="form-control" id="typeahead-http{{i}}"
                   placeholder="Search Particular Name...." tabindex="-1"
                   type="text"/>
          </td>
          <td>
            <input [(ngModel)]="damage.available_qty[i]" [readOnly]="true"
                   class="form-control text-center " maxlength="8"
                   name="available_qty{{i}}" tabindex="-1" type="text">
          </td>
          <td>
            <input [(ngModel)]="damage.quantity_arr[i]" [readOnly]="true"
                   class="form-control text-center " maxlength="8"
                   name="purchased_quantity_arr{{i}}" tabindex="-1" type="text">
          </td>
          <td>
            <input [(ngModel)]="damage.amount_arr[i]" [readOnly]="true" class="form-control text-right "
                   maxlength="10"
                   name="amount_arr{{i}}" tabindex="-1" type="text">
          </td>
          <td>
            <input [(ngModel)]="damage.unitprice_arr[i]" [readOnly]="true"
                   class="form-control  text-right " maxlength="7"
                   name="unitprice_arr{{i}}" tabindex="-1" type="text">
          </td>
          <td>
            <input (focusout)="getDamageUnitPrice();total();getDamageQty()"
                   [(ngModel)]="damage.damage_quantity_arr[i]"
                   [disabled]="damage.check[i] == false || damage.available_qty[i] == 0"
                   class="form-control  "
                   maxlength="7" name="damage_quantity_arr{{i}}" type="text"
            >
          </td>
          <td>
            <input (focusout)="getDamageUnitPrice();total()" [(ngModel)]="damage.damage_amount_arr[i]"
                   [disabled]="damage.check[i] == false" [readOnly]="true"
                   class="form-control text-right " maxlength="7"
                   name="damage_amount_arr{{i}}" tabindex="-1" type="text">
          </td>
          <td>
            <textarea (focusout)="getDamageUnitPrice();" [(ngModel)]="damage.damage_reason_arr[i]"
                      [disabled]="damage.check[i] == false" class="form-control "
                      name="damage_reason_arr{{i}}"
                      style="height: 35px;" type="text"></textarea>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td colspan="9" style="text-align: right"><label>Total Cost&nbsp;&nbsp;&nbsp; </label></td>
          <td style="text-align: right;"><label>{{ damage.total_amount | number : '1.2-2' }}</label></td>
        </tr>
        </tfoot>
      </table>
      <div class="clearfix"></div>
    </div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>
    <div class="row ">
      <div class="col-lg-7 pull-right">
        <button (click)="saveDamageProducts();" *ngIf="user_rights.ADD == '1'"
                class="btn btn-info btn-sm ng-star-inserted"
                type="button">&nbsp;Save&nbsp;
        </button>&nbsp;&nbsp;&nbsp;
      </div>
    </div>
  </div>
</div>
